// extracted by mini-css-extract-plugin
export default {"inputContainer":"styles_inputContainer__v9pU4","input":"styles_input__aGgPT"};